import { useQuery } from "@tanstack/vue-query";
import baseAPI from "@/api/base";
import { computed, Ref } from "vue";

export interface SMSMessage {
  id: string;
  messageSid: string;
  from: string;
  to: string;
  body: string;
  direction: string;
  status: string;
  errorCode?: string;
  errorMessage?: string;
  numSegments: number;
  numMedia: number;
  mediaUrls?: string[];
  contactId?: string;
  userId?: string;
  organizationId: string;
  phoneNumberId?: string;
  conversationId?: string;
  contactPhoneId?: string;
  sentAt: string;
  deliveredAt?: string;
  createdAt: string;
}

export interface SMSConversationMessagesResponse {
  messages: SMSMessage[];
  total: number;
  limit: number;
  offset: number;
}

export function useSMSConversationMessages(conversationId: Ref<string | null>) {
  const enabled = computed(() => !!conversationId.value);

  return useQuery({
    queryKey: ["sms-conversation-messages", conversationId],
    queryFn: async (): Promise<SMSConversationMessagesResponse> => {
      if (!conversationId.value)
        return {
          messages: [],
          total: 0,
          limit: 50,
          offset: 0,
        };
      const response = await baseAPI.get(
        `/twilio/sms/conversations/${conversationId.value}/messages`
      );
      return response.data.data;
    },
    enabled,
    staleTime: 1000 * 60 * 1,
    gcTime: 1000 * 60 * 5,
  });
}
